document.addEventListener("DOMContentLoaded", function () {
    const skateboard_add_to_cart = document.getElementById(
        "clw-pcs-add-to-cart"
    );
    const inputInstructions = document.getElementById("instructions-input");

    const FREE_SHIP_THRESHOLD = 25;

    const CLW_PCS_CART_BTN_HTML = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M2 3h3l2.4 12.4a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.6L23 6H6"/></svg> Add to cart`;

    const CLW_PCS_CART_LOADING_HTML = `<span class="clw-pcs-cart-loading"><svg class="clw-pcs-cart-loading__icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-6.22-8.56"/></svg>Adding to cart</span>`;

    // **State object to manage selected values**
    const state = {
        uploadedImage: null,
        editedImage: null,
        gripTape: "No",
        wallMount: "No",
        Instructions: "",
        price: 89.9,
    };

    let isFromFinishEditing = false;

    const MAX_CHARS_TEXT = 200;
    const counterEl2 = document.getElementById("instructions-char-count");

    // **Function to animate price changes**
    function animatePriceChange(targetElement, start, end, duration = 500) {
        let startTime = null;

        function step(timestamp) {
            if (!startTime) startTime = timestamp;
            const progress = Math.min((timestamp - startTime) / duration, 1);
            const currentValue = start + (end - start) * progress;

            targetElement.textContent = currentValue.toFixed(2);

            if (progress < 1) {
                requestAnimationFrame(step);
            }
        }

        requestAnimationFrame(step);
    }

    inputInstructions.addEventListener("input", () => {
        // 1) Trim any extra characters
        if (inputInstructions.value.length > MAX_CHARS_TEXT) {
            inputInstructions.value = inputInstructions.value.slice(
                0,
                MAX_CHARS_TEXT
            );
        }
        // 2) Update the counter
        const remaining = MAX_CHARS_TEXT - inputInstructions.value.length;
        counterEl2.textContent = `${remaining} character(s) left`;
    });

    function updateBuyBar(total) {
        const shippingWrap = document.getElementById("clw-pcs-shipping");
        const fillEl = document.getElementById("clw-pcs-shipping-fill");
        const textEl = document.getElementById("clw-pcs-shipping-text");
        if (!shippingWrap || !fillEl) return;

        const numericTotal = parseFloat(total) || 0;
        const toFree = FREE_SHIP_THRESHOLD - numericTotal;
        if (toFree <= 0) {
            shippingWrap.classList.add("is-free");
            if (textEl) {
                textEl.innerHTML =
                    "You unlocked <strong>free shipping</strong>";
            }
            fillEl.style.width = "100%";
        } else {
            shippingWrap.classList.remove("is-free");
            if (textEl) {
                textEl.innerHTML = `Add <strong>$${toFree.toFixed(
                    2
                )}</strong> more for <strong>free shipping</strong>`;
            }
            const pct = Math.min(
                100,
                Math.round(
                    (numericTotal / FREE_SHIP_THRESHOLD) * 100
                )
            );
            fillEl.style.width = `${pct}%`;
        }
    }

    function playCartButtonShine() {
        const btn = document.getElementById("clw-pcs-add-to-cart");
        if (!btn || btn.classList.contains("loading")) return;
        btn.classList.remove("shine");
        void btn.offsetWidth;
        btn.classList.add("shine");
    }

    function setupCartButtonShine() {
        const btn = document.getElementById("clw-pcs-add-to-cart");
        if (!btn || btn.dataset.shineBound) return;
        btn.dataset.shineBound = "true";
        setTimeout(playCartButtonShine, 1500);
        setInterval(playCartButtonShine, 5000);
    }

    function setupMobileStickyBuybar() {
        const sticky = document.getElementById("clw-pcs-buybar-sticky");
        const trigger = document.getElementById("clw-pcs-buybar-sticky-trigger");
        const spacer = document.getElementById("clw-pcs-buybar-sticky-spacer");
        const configCard = document.querySelector(
            "#clw-pcs-custom-fields .clw-pcs-config-card"
        );
        const pricingBox = document.getElementById("pricing-box");
        if (!sticky || !trigger || !spacer) return;

        const mobileMq = window.matchMedia("(max-width: 768px)");

        const resetStickyLayout = () => {
            sticky.classList.remove("is-stuck");
            sticky.style.left = "";
            sticky.style.width = "";
            sticky.style.paddingLeft = "";
            sticky.style.paddingRight = "";
            spacer.style.height = "0";
        };

        const syncStickyDimensions = () => {
            if (!mobileMq.matches || !sticky.classList.contains("is-stuck")) {
                if (!mobileMq.matches) resetStickyLayout();
                return;
            }
            const widthSource = configCard || pricingBox;
            if (widthSource) {
                const rect = widthSource.getBoundingClientRect();
                sticky.style.left = `${rect.left}px`;
                sticky.style.width = `${rect.width}px`;
            }
            if (pricingBox) {
                const pb = getComputedStyle(pricingBox);
                sticky.style.paddingLeft = pb.paddingLeft;
                sticky.style.paddingRight = pb.paddingRight;
            }
            spacer.style.height = `${sticky.offsetHeight}px`;
        };

        const setStuck = (stuck) => {
            if (!mobileMq.matches) {
                resetStickyLayout();
                return;
            }
            sticky.classList.toggle("is-stuck", stuck);
            if (stuck) syncStickyDimensions();
            else {
                sticky.style.left = "";
                sticky.style.width = "";
                sticky.style.paddingLeft = "";
                sticky.style.paddingRight = "";
                spacer.style.height = "0";
            }
        };

        const scrollRoot =
            document.scrollingElement || document.documentElement;

        const getViewportHeight = () =>
            window.visualViewport?.height || window.innerHeight || 0;

        const computeShouldStick = () => {
            const stickLine = Math.max(0, getViewportHeight() - 1);
            return trigger.getBoundingClientRect().top <= stickLine;
        };

        const updateStuckFromScroll = () => {
            if (!mobileMq.matches) {
                resetStickyLayout();
                return;
            }
            const stuck = computeShouldStick();
            if (sticky.classList.contains("is-stuck") !== stuck) {
                setStuck(stuck);
            } else if (stuck) {
                syncStickyDimensions();
            }
        };

        mobileMq.addEventListener("change", (e) => {
            if (!e.matches) resetStickyLayout();
            else updateStuckFromScroll();
        });

        const onLayoutChange = () => {
            updateStuckFromScroll();
            syncStickyDimensions();
        };

        window.addEventListener("resize", onLayoutChange);
        scrollRoot.addEventListener("scroll", updateStuckFromScroll, {
            passive: true,
        });
        if (window.visualViewport) {
            window.visualViewport.addEventListener("resize", onLayoutChange);
            window.visualViewport.addEventListener("scroll", updateStuckFromScroll);
        }
        updateStuckFromScroll();
    }

    // **Price calculation function**
    function calculatePrice() {
        let basePrice = 89.9; // Base skateboard price

        // Add cost for grip tape if selected
        if (state.gripTape === "Yes – apply for me") {
            basePrice += 25.0; // Additional cost for grip tape application
        } else if (state.gripTape === "Yes – do not apply") {
            basePrice += 15.0; // Cost for grip tape only
        }

        // Add cost for wall mount if selected
        if (state.wallMount === "Yes") {
            basePrice += 15.0; // Additional cost for wall mount
        }

        const finalPrice = basePrice.toFixed(2);
        state.price = finalPrice;
        return finalPrice;
    }

    // **Update price display**
    function updatePriceDisplay() {
        const priceElement = document.getElementById("clw-pcs-final-price");
        if (priceElement) {
            const oldPrice = parseFloat(priceElement.textContent) || 0;
            const newPrice = parseFloat(calculatePrice());
            animatePriceChange(priceElement, oldPrice, newPrice);
            updateBuyBar(newPrice);
        }
    }

    // **Setup form event handlers**
    function setupFormHandlers() {
        // Handle grip tape selection
        const gripTapeInputs = document.querySelectorAll(
            'input[name="properties[Include Grip Tape]"]'
        );
        gripTapeInputs.forEach((input) => {
            input.addEventListener("change", function () {
                if (this.checked) {
                    state.gripTape = this.value;
                    console.log("Grip tape selected:", state.gripTape);
                    updatePriceDisplay(); // Update price when grip tape changes
                }
            });
        });

        const instructionsInput = document.querySelector(
            'textarea[name="properties[Instructions]"]'
        );
        if (instructionsInput) {
            instructionsInput.addEventListener("input", function () {
                state.Instructions = this.value;
                console.log("Instructions changed to:", state.Instructions);
            });
        }

        // Handle wall mount selection
        const wallMountInputs = document.querySelectorAll(
            'input[name="properties[Include Wall Mount]"]'
        );
        wallMountInputs.forEach((input) => {
            input.addEventListener("change", function () {
                if (this.checked) {
                    state.wallMount = this.value;
                    console.log("Wall mount selected:", state.wallMount);
                    updatePriceDisplay(); // Update price when wall mount changes
                }
            });
        });
    }

    // **Image upload and preview functionality**
    const artbox = document.getElementById("upload-artbox");
    const designerTool = document.getElementById("designerTool");
    const designerToolCloseBtn = document.getElementById(
        "designer-tool-close-btn"
    );
    const closeToolPopup = document.getElementById("close-tool-popup");
    const cancelCloseTool = document.getElementById("cancel-close-tool");
    const confirmCloseTool = document.getElementById("confirm-close-tool");
    const previewBox = document.getElementById("preview-box");
    const deleteImage = document.getElementById("delete-image");
    const btnEditImage = document.getElementById("btnEditImage");
    const errorMessage = document.getElementById("upload-file-error");
    function fileInputChangeHandler(fileInput) {
        const chooseFileBtn = document.getElementById("choose-file-btn");

        // Clear any existing click handlers to prevent duplicates
        chooseFileBtn.onclick = null;

        // Set up new click handler
        chooseFileBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            fileInput.value = "";
            fileInput.click();
        });

        const dropZone = document.querySelector(".clw-pcs-upload-zone");
        if (dropZone) {
            ["dragenter", "dragover"].forEach((evt) => {
                dropZone.addEventListener(evt, (e) => {
                    e.preventDefault();
                    dropZone.classList.add("is-dragover");
                });
            });
            ["dragleave", "drop"].forEach((evt) => {
                dropZone.addEventListener(evt, (e) => {
                    e.preventDefault();
                    dropZone.classList.remove("is-dragover");
                });
            });
            dropZone.addEventListener("drop", (e) => {
                const file = e.dataTransfer?.files?.[0];
                if (!file) return;
                const dt = new DataTransfer();
                dt.items.add(file);
                fileInput.files = dt.files;
                fileInput.dispatchEvent(new Event("change", { bubbles: true }));
            });
        }

        btnEditImage.addEventListener("click", () => {
            designerTool.classList.add("active")
        })

        fileInput.onchange = async (event) => {
            const file = event.target.files[0];
            if (!file) return;

            const img = document.querySelector("#preview-image");
            const reader = new FileReader();

            if (skateboard_add_to_cart) {
                skateboard_add_to_cart.disabled = false;
                playCartButtonShine();
            }

            // Validate file type
            const allowedTypes = [
                "image/jpeg",
                "image/jpg",
                "image/png",
                "image/svg+xml",
                "application/pdf",
            ];
            if (
                !allowedTypes.includes(file.type) &&
                !file.name.match(/\.(ai|eps|tiff)$/i)
            ) {
                errorMessage.classList.add("active");
                errorMessage.textContent =
                    "Please upload a valid image file (.ai, .eps, .jpg, .png, .pdf, .tiff, .svg)";
                fileInput.value = "";
                return;
            }

            reader.onload = async (e) => {
                const tempImg = new Image();
                tempImg.src = e.target.result;

                tempImg.onload = async () => {
                    const width = tempImg.naturalWidth;
                    const height = tempImg.naturalHeight;

                    // Basic size validation
                    if (width < 300 || height < 300) {
                        errorMessage.classList.add("active");
                        errorMessage.textContent =
                            "Please upload an image with at least 300x300 pixels.";
                        fileInput.value = "";
                        return;
                    }

                    img.src = e.target.result;

                    img.onload = async () => {
                        try {
                            // Calculate display dimensions in inches (approximate)
                            const dpi = 72; // Default DPI for display
                            const widthInches = (width / dpi).toFixed(2);
                            const heightInches = (height / dpi).toFixed(2);

                            // Update UI with dimensions
                            document.getElementById(
                                "width-inch"
                            ).textContent = `${8}"`;
                            document.getElementById(
                                "height-inch"
                            ).textContent = `${31}"`;

                            // Show preview and hide upload area
                            artbox.style.display = "none";
                            previewBox.style.display = "block";
                            if (!isFromFinishEditing) {
                                designerTool.classList.add("active");
                            }
                            errorMessage.classList.remove("active");

                            // Store the uploaded image in state
                            state.uploadedImage = file;

                            // Update price based on new dimensions
                            updatePriceDisplay();

                            isFromFinishEditing = false;

                            console.log("Image uploaded successfully:", file.name);
                        } catch (error) {
                            console.error("Error processing image:", error);
                            errorMessage.classList.add("active");
                            errorMessage.textContent =
                                "An error occurred while processing the image.";
                            fileInput.value = "";
                        }
                    };
                };

                tempImg.onerror = () => {
                    errorMessage.classList.add("active");
                    errorMessage.textContent =
                        "Failed to load image. It might be corrupted.";
                    fileInput.value = "";
                };
            };

            reader.onerror = () => {
                errorMessage.classList.add("active");
                errorMessage.textContent = "Failed to read file.";
                fileInput.value = "";
            };

            reader.readAsDataURL(file);
        };
    }

    // **Delete image handler**
    deleteImage.addEventListener("click", (e) => {
        // Show upload area and hide preview
        artbox.style.display = "block";
        designerTool.classList.remove("active");
        previewBox.style.display = "none";
        errorMessage.classList.remove("active");

        // Reset state
        state.uploadedImage = null;
        // state.gripTape = "No";
        // state.wallMount = "No";

        // Clear file input
        const fileInput = document.querySelector("#upload-file");
        if (fileInput) fileInput.value = "";

        // Reset price to base price
        updatePriceDisplay();

        console.log("Image deleted");
    });

    designerToolCloseBtn.addEventListener("click", (e) => {
        closeToolPopup.classList.add("active");
    });

    cancelCloseTool.addEventListener("click", (e) => {
        closeToolPopup.classList.remove("active");
    });

    confirmCloseTool.addEventListener("click", (e) => {
        closeToolPopup.classList.remove("active");
        deleteImage.click();
    });

    function addToCartEvent() {
        if (!skateboard_add_to_cart)
            return console.error("Add-to-cart button not found");

        skateboard_add_to_cart.addEventListener("click", async (e) => {
            e.preventDefault();

            console.log("Working SKateboard Add To Cart  Button")

            /* basic validation */
            if (!state.uploadedImage) {
                alert("Please upload an image first!");
                return;
            }

            /* UI feedback */
            skateboard_add_to_cart.classList.remove("shine");
            skateboard_add_to_cart.disabled = true;
            skateboard_add_to_cart.classList.add("loading");
            skateboard_add_to_cart.innerHTML = CLW_PCS_CART_LOADING_HTML;

            /* CPC IDs for the skateboard product */
            const calculatorId = "ea28e1fad2354";
            const productId = 7693255409712;
            const variants = [];
            const cartItems = [];
            const file = state.uploadedImage;
            const skateboardImage = state.editedImage;

            if (!file) {
                alert("No image file selected!");
                return;
            }

            // if the state.gripTape is Yes – do not apply set it to Yes / Do not apply it
            if (state.gripTape === "Yes – do not apply") {
                state.gripTape = "Yes / Do not apply it";
            }
            // if the state.gripTape is Yes – apply for me set it to Yes / Yes apply it for me
            if (state.gripTape === "Yes – apply for me") {
                state.gripTape = "Yes / Yes apply it for me";
            }

            const instructionsInput = document.querySelector(
                'textarea[name="properties[Instructions]"]'
            );

            const instructionsValue = instructionsInput?.value?.trim() || "";

            console.log("🛒 Adding to cart with properties:", {
                "Upload Image": file.name,
                "Include Grip Tape?": state.gripTape,
                "Include Wall Mount?": state.wallMount,
                "Custom Instructions": instructionsValue,
            });

            /* Build properties object */
            const props = {
                "Upload Image": file.name,
                "Skateboard Image": skateboardImage,
                "Include Grip Tape?": state.gripTape,
                "Include Wall Mount?": state.wallMount,
                "Custom Instructions": instructionsValue,
            };

            try {
                /* 1️⃣  Create / fetch dynamic variant from CustomPriceCalculator */
                const payload = {
                    calculatorId,
                    productId,
                    properties: props,
                };

                const res = await fetch(
                    "https://api.custompricecalculator.com/api/v1/variant",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json",
                        },
                        body: JSON.stringify(payload),
                    }
                );

                const json = await res.json();
                const variantId =
                    typeof json === "string" ? json : json.variantId || json.id;

                if (!variantId) throw new Error("Invalid variantId received");
                variants.push({ id: variantId, props: props });

                // Now add each variant to the cart
                for (const variant of variants) {
                    const formData = new FormData();
                    formData.append("id", variant.id);
                    formData.append("quantity", 1);

                    Object.entries(variant.props).forEach(([key, value]) => {
                        formData.append(`properties[${key}]`, value);
                    });

                    console.log("🛒 Adding variant to cart:", variant.id, variant.props);

                    if (file) {
                        formData.append("properties[Upload Image]", file);
                    }

                    const cartAddRes = await fetch("/cart/add.js", {
                        method: "POST",
                        body: formData,
                    });

                    const cartAddJson = await cartAddRes.json();
                    cartItems.push(cartAddJson); // Store cart items for verification
                }

                // Wait for Shopify cart to settle
                await new Promise((r) => setTimeout(r, 300));

                // Open mini-cart
                const timestamp = Date.now();
                const html = await fetch(
                    `/cart?section_id=mini-cart&t=${timestamp}`
                ).then((r) => r.text());

                const fake = document.createElement("div");
                fake.innerHTML = html;
                const miniCartHTML = fake.querySelector("cart-drawer")?.outerHTML;
                const cartDrawer = document.querySelector("cart-drawer");

                if (cartDrawer && miniCartHTML) {
                    cartDrawer.dispatchEvent(
                        new CustomEvent("cart:refresh", {
                            bubbles: true,
                            detail: {
                                cart: { sections: { "mini-cart": miniCartHTML } },
                                openMiniCart: true,
                            },
                        })
                    );
                }

                // Additional verification after cart opens
                setTimeout(() => {
                    if (!cartDrawer) return;

                    const lineItems = cartDrawer.querySelectorAll("line-item");

                    lineItems.forEach((lineItem) => {
                        const desktopPriceContainer = lineItem.querySelector(
                            ".line-item__price-list-container .price"
                        );

                        const mobilePriceContainer = lineItem.querySelector(
                            ".product-item-meta__price-list-container .price-list.hidden-tablet-and-up .price"
                        );

                        if (!desktopPriceContainer && !mobilePriceContainer) return;

                        const priceText = (
                            desktopPriceContainer || mobilePriceContainer
                        ).textContent.trim();
                        const isFree = /Free|\$0\.00/.test(priceText);

                        let variantId;
                        const productLink = lineItem.querySelector("a[href*='?variant=']");
                        if (productLink?.href.includes("variant=")) {
                            variantId = productLink.href.split("variant=")[1].split("&")[0];
                        }

                        if (!variantId) {
                            const removeBtn = lineItem.querySelector(
                                "a[href*='/cart/change?id=']"
                            );
                            const removeHref = removeBtn?.getAttribute("href") || "";
                            const match = removeHref.match(/id=(\d+):/);
                            variantId = match?.[1];
                        }

                        if (isFree && variantId) {
                            // Find matching item in our cartItems array
                            const matchingItem = cartItems.find(
                                (item) => String(item.id) === variantId
                            );

                            if (matchingItem) {
                                const correctPrice = (matchingItem.price / 100).toFixed(2);

                                const imageWrapper = lineItem.querySelector(
                                    ".line-item__image-wrapper"
                                );
                                const productThumbnail = imageWrapper.querySelector(
                                    "img.line-item__image"
                                );
                                const productTitle = lineItem.querySelector(
                                    ".product-item-meta .product-item-meta__title"
                                );

                                if (!productThumbnail) {
                                    const imgSrc = document.querySelector(
                                        ".product__thumbnail-item .product__thumbnail img"
                                    )?.src;
                                    if (imgSrc) {
                                        imageWrapper.innerHTML += `
                        <img src="${imgSrc}" alt="" srcset="${imgSrc}" width="1024" height="1024" loading="lazy" sizes="(max-width: 740px) 80px, 92px" class="line-item__image">
                      `;
                                    }
                                }

                                if (productTitle && productTitle.textContent.trim() === "") {
                                    const metaTitle = document.querySelector(
                                        ".product__info .product-meta__title"
                                    );
                                    if (metaTitle) {
                                        productTitle.textContent = metaTitle.textContent;
                                    }
                                }

                                // Update both prices
                                const updatedPriceHTML = `
                    <span class="visually-hidden">Sale price</span>
                    $${correctPrice}
                  `;
                                if (desktopPriceContainer) {
                                    desktopPriceContainer.innerHTML = updatedPriceHTML;
                                }
                                if (mobilePriceContainer) {
                                    mobilePriceContainer.innerHTML = updatedPriceHTML;
                                }
                            }
                        }
                    });
                }, 500); // Slightly longer delay for multiple items

                // Update cart count
                setTimeout(async () => {
                    const cartJson = await fetch("/cart.js").then((res) => res.json());
                    const cartCountEl = document.querySelector("cart-count");
                    if (cartCountEl) {
                        cartCountEl.textContent = cartJson.item_count;
                    }
                }, 300);
            } catch (err) {
                console.error("🚨 Error during cart add:", err);
                alert("Something went wrong while adding items to the cart.");
            } finally {
                skateboard_add_to_cart.disabled = false;
                skateboard_add_to_cart.classList.remove("loading");
                skateboard_add_to_cart.innerHTML = CLW_PCS_CART_BTN_HTML;
            }
        });
    }

    function updateCalculator() {
        const calculator = document.querySelector("#calculator");

        if (!calculator) return console.error("Calculator not found");

        const fileInput = document.querySelector("#upload-file");

        if (fileInput) {
            fileInput.setAttribute(
                "accept",
                ".ai,.eps,.jpg,.jpeg,.png,.pdf,.tiff,.svg"
            );
        }

        if (calculator) {
            const formFileInput = calculator.querySelector(
                "input[name='properties[Upload Image]']"
            );
        }

        if (state.gripTape) {
            calculator.querySelector(
                "input[name='properties[Include Grip Tape?]']"
            ).value = state.gripTape;
        }

        if (state.wallMount) {
            calculator.querySelector(
                "input[name='properties[Include Wall Mount?]']"
            ).value = state.wallMount;
        }

        if (state.Instructions) {
            calculator.querySelector(
                "textarea[name='properties[Instructions]']"
            ).value = state.Instructions;
        }

        calculatePrice();
        updatePriceDisplay();
    }

    // **Mutation Observer to watch for calculator form loading**
    // const observer = new MutationObserver(() => {
    //   if (document.querySelector("#calculator")) {
    //     observer.disconnect();
    //     // **Initialize when DOM is ready**
    //     updateCalculator();
    //     addToCartEvent();
    //   }
    // });

    // **Initialize the skateboard customizer**
    function initializeSkateboardCustomizer() {
        console.log("Initializing skateboard customizer...");

        // Setup form handlers for radio buttons
        setupFormHandlers();

        updatePriceDisplay();

        const fileInput = document.querySelector("#upload-file");
        fileInputChangeHandler(fileInput);

        addToCartEvent();
        setupCartButtonShine();
        setupMobileStickyBuybar();
        updateBuyBar(state.price);

        console.log("Skateboard customizer initialized successfully");
    }

    initializeSkateboardCustomizer();

    // observer.observe(document.body, { childList: true, subtree: true });

    // -- StickerDesigner CLASS --
    class StickerDesigner {
        constructor() {
            this.canvas = new fabric.Canvas("stickerCanvas");
            this.uploadedImage = null;
            this.originalImageFile = null;
            this.clipPath = null;
            this.currentShape = null;
            this.guidelines = null;
            this.tireBoxes = [];

            this.lastValidShape = "Skateboard";

            // We'll store the contour object here for re-aligning on AutoAdjust
            this.contourObj = null;
            this.icons = {
                resizeLeft:
                    "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/resize-left.png",
                resizeRight:
                    "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/resize-right.png",
            };

            this.init();
        }

        init() {
            this.setupCanvas();
            this.setupEventListeners();
            this.setupCustomControls();
            this.updateCanvasSize();
        }

        // -------------------------------------------------------------
        // 1) Basic Canvas Setup
        // -------------------------------------------------------------
        setupCanvas() {
            this.canvas.controlsAboveOverlay = true;
            this.canvas.selection = false;
            this.canvas.preserveObjectStacking = true;
        }

        setupEventListeners() {
            // Window resize
            $(window).on("resize", () => this.handleResize());

            // File input => user uploads
            $("#upload-file").on("change", (e) => {
                this.handleImageUpload(e);
            });

            $("#toggleGuides").on("change", (e) => {
                const visible = e.target.checked;
                this.toggleGuidelines(visible);
            });

            // Auto adjust
            $("#autoAdjust").on("click", () => this.handleAutoAdjust());

            $("#zoomRange").on("input", (e) => this.setZoom(parseFloat(e.target.value)));

            $(".align-btn").on("click", (e) => {
                const alignType = $(e.currentTarget).data("align");
                this.alignUploadedImage(alignType);
            });

            // Finish Editing
            $("#sbFinishEditing").on("click", () => this.finishEditing());

            // Remove image
            $("#confirm-close-tool").on("click", () => this.handleRemoveImage());
        }

        handleResize() {
            this.updateCanvasSize();
            if (this.uploadedImage && this.clipPath) {
                // Recreate non-contour shapes on resize
                if (this.currentShape !== "Contour-Cut") {
                    this.drawClipPath(this.currentShape);
                }
                this.centerObjects();
                this.resizeImageToFitClipPath();
            }
            this.canvas.renderAll();
        }

        setZoom(scale) {
            if (!this.uploadedImage) return;

            this.uploadedImage.scaleX = scale;
            this.uploadedImage.scaleY = scale;

            this.centerImage();
            this.canvas.renderAll();
        }

        updateCanvasSize() {
            const container = $("#canvasContainer");
            this.canvas.setWidth(container.width());
            this.canvas.setHeight(container.height());
            this.canvas.renderAll();
        }

        // -------------------------------------------------------------
        // 2) Custom Controls (corner icons) -- optional
        // -------------------------------------------------------------
        setupCustomControls() {
            // Preload corner icons if you want custom icons
            const resizeLeftImg = new Image();
            resizeLeftImg.src = this.icons.resizeLeft;

            const resizeRightImg = new Image();
            resizeRightImg.src = this.icons.resizeRight;

            // Apply once they load
            resizeLeftImg.onload = () =>
                this.applyCustomCornerIcons(resizeLeftImg, resizeRightImg);
            resizeRightImg.onload = () =>
                this.applyCustomCornerIcons(resizeLeftImg, resizeRightImg);

            // Basic styling
            fabric.Object.prototype.transparentCorners = false;
            fabric.Object.prototype.cornerColor = "black";
            fabric.Object.prototype.borderColor = "black";
            fabric.Object.prototype.cornerStyle = "circle";
            fabric.Object.prototype.cornerStrokeColor = "black";
            fabric.Object.prototype.borderScaleFactor = 1;
        }

        applyCustomCornerIcons(iconLeft, iconRight) {
            const renderIcon = (icon) => {
                return function (ctx, left, top, _styleOverride, fabricObject) {
                    const size = this.cornerSize;
                    ctx.save();
                    ctx.translate(left, top);
                    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
                    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
                    ctx.restore();
                };
            };

            const setCustomControl = (controlKey, options) => {
                const ctrl = fabric.Object.prototype.controls[controlKey];
                if (ctrl) Object.assign(ctrl, options);
            };

            // Example overrides for corners
            const controlSettings = {
                tl: { render: renderIcon(iconLeft), cornerSize: 30 },
                tr: { render: renderIcon(iconRight), cornerSize: 30 },
                bl: { render: renderIcon(iconRight), cornerSize: 30 },
                br: { render: renderIcon(iconLeft), cornerSize: 30 },
            };

            Object.entries(controlSettings).forEach(([k, opt]) =>
                setCustomControl(k, opt)
            );

            // Hide other mid controls
            fabric.Object.prototype.setControlsVisibility({
                mt: false,
                ml: false,
                mr: false,
                mb: false,
            });
        }

        // -------------------------------------------------------------
        // 3) Image Upload Logic
        // -------------------------------------------------------------
        async handleImageUpload(event) {
            const file = event.target.files[0];
            if (!file) return;

            if (!this.validateImageFile(file)) return;

            $("#image-upload-label").css("display", "none");
            $("#filename").css("display", "flex");
            $("#filename span").text(file.name);

            // ✅ Reset the entire canvas & remove previous objects
            this.canvas.clear();
            this.uploadedImage = null;
            this.clipPath = null;
            this.contourObj = null;
            this.currentShape = null;

            this.originalImageFile = file; // Save new file reference

            // ✅ Reset contour settings to defaults
            this.contourBorderThickness = 90; // Default small contour
            this.marginPercent = 0.08; // Default margin factor

            // ✅ Enable UI options
            $("#sbFinishEditing").prop("disabled", false);
            $("#autoAdjust").prop("disabled", false);
            $("#remove").prop("disabled", false);

            try {
                let imgObj = await this.loadImageFile(file);

                // 🚀 **Check if cropping is needed before applying it**
                const croppedImg = await this.cropTransparentAreas(imgObj);
                if (croppedImg) {
                    imgObj = croppedImg; // Use cropped image if gaps were found
                }

                this.uploadedImage = imgObj;
                this.centerImage();

                // ✅ **Draw default shape ("Skateboard") and fit the new image inside it**
                this.drawClipPath();
            } catch (err) {
                this.showError("Image load failed. Please try a different file.");
                this.handleRemoveImage();
            }
        }

        async cropTransparentAreas(imgObj, alphaThreshold = 30, padding = 2.5) {
            return new Promise((resolve, reject) => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");

                canvas.width = imgObj.width;
                canvas.height = imgObj.height;

                const tempImg = new Image();
                tempImg.src = imgObj.toDataURL("image/png"); // Preserve transparency
                tempImg.onload = () => {
                    ctx.drawImage(tempImg, 0, 0);

                    // Get pixel data
                    const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    const pixels = imgData.data;

                    let minX = canvas.width,
                        minY = canvas.height,
                        maxX = 0,
                        maxY = 0;

                    // Loop through pixels to find actual content
                    for (let y = 0; y < canvas.height; y++) {
                        for (let x = 0; x < canvas.width; x++) {
                            const alpha = pixels[(y * canvas.width + x) * 4 + 3]; // Get alpha channel

                            if (alpha > alphaThreshold) {
                                // Detect non-transparent pixel
                                if (x < minX) minX = x;
                                if (y < minY) minY = y;
                                if (x > maxX) maxX = x;
                                if (y > maxY) maxY = y;
                            }
                        }
                    }

                    // ✅ Check if image has extra transparent gaps
                    const hasExtraGap =
                        minX > padding ||
                        minY > padding ||
                        maxX < canvas.width - padding ||
                        maxY < canvas.height - padding;

                    // ❌ If no extra gaps, return nothing (null)
                    if (!hasExtraGap) {
                        resolve(null);
                        return;
                    }

                    // ✅ **Apply a small padding to avoid harsh cuts**
                    minX = Math.max(0, minX - padding);
                    minY = Math.max(0, minY - padding);
                    maxX = Math.min(canvas.width, maxX + padding);
                    maxY = Math.min(canvas.height, maxY + padding);

                    const newWidth = maxX - minX;
                    const newHeight = maxY - minY;

                    // Create a new canvas for the cropped image
                    const croppedCanvas = document.createElement("canvas");
                    const croppedCtx = croppedCanvas.getContext("2d");
                    croppedCanvas.width = newWidth;
                    croppedCanvas.height = newHeight;

                    // ✅ **Apply a soft blur to smooth edges slightly**
                    croppedCtx.filter = "blur(0.3px)";
                    croppedCtx.drawImage(
                        canvas,
                        minX,
                        minY,
                        newWidth,
                        newHeight,
                        0,
                        0,
                        newWidth,
                        newHeight
                    );

                    // Convert back to Fabric.js image
                    fabric.Image.fromURL(
                        croppedCanvas.toDataURL("image/png"),
                        (croppedImg) => {
                            resolve(croppedImg);
                        }
                    );
                };

                tempImg.onerror = reject;
            });
        }

        validateImageFile(file) {
            const validTypes = ["image/png", "image/jpeg"];
            const maxSize = 5 * 1024 * 1024; // 5MB

            if (!validTypes.includes(file.type)) {
                this.showError("Invalid file type. Please upload PNG or JPEG.");
                return false;
            }
            if (file.size > maxSize) {
                this.showError("File size exceeds 5MB limit.");
                return false;
            }
            return true;
        }

        loadImageFile(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    fabric.Image.fromURL(
                        e.target.result,
                        (img) => {
                            // Get Canvas Dimensions
                            const canvasWidth = this.canvas.width;
                            const canvasHeight = this.canvas.height;

                            // Minimum recommended resolution
                            const minWidth = 500; // Adjust as needed
                            const minHeight = 500; // Adjust as needed

                            // Check if the image is low resolution
                            if (img.width < minWidth || img.height < minHeight) {
                                this.showWarning(
                                    `Low resolution detected: ${img.width}x${img.height}px. 
                              This may affect print quality. Consider using a higher-resolution image.`
                                );
                            } else {
                                $("#canvasMessage").hide(); // Hide any previous warnings
                            }

                            // Calculate Scaling Factor
                            const scaleX = canvasWidth / img.width;
                            const scaleY = canvasHeight / img.height;
                            const scale = Math.min(scaleX, scaleY, 1); // Prevent Upscaling

                            // Apply Scaling
                            img.scale(scale);

                            // Center the Image
                            img.set({
                                originX: "center",
                                originY: "center",
                                left: canvasWidth / 2,
                                top: canvasHeight / 2,
                            });

                            resolve(img);
                        },
                        { crossOrigin: "anonymous" }
                    ); // Fix potential CORS issues
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        }

        clearCanvas() {
            this.canvas.clear();
            this.canvas.clipPath = null;
            this.clipPath = null;
            this.guidelines = null;
            this.contourObj = null;
        }

        toggleGuidelines(visible) {
            if (this.guidelineObjects) {
                this.guidelineObjects.forEach((obj) => {
                    obj.visible = visible;
                });
            }

            if (this.tireBoxes) {
                this.tireBoxes.forEach((box) => {
                    box.visible = visible;
                });
            }

            this.canvas.renderAll();
        }

        addImageToCanvas() {
            if (this.uploadedImage) {
                this.canvas.add(this.uploadedImage);
            }
        }

        /**
         * Draw the user-selected shape as the new clip path.
         * Also handles "Contour-Cut".
         */
        async drawClipPath() {
            this.clearCanvas();

            // draw base and set clipPath
            this.createSkateboard();

            // ✅ add outlines
            if (this.guidelineObjects?.length) {
                this.guidelineObjects.forEach((obj) => {
                    this.canvas.add(obj);
                });
            }

            this.resizeImageToFitClipPath?.();
            this.applyClipPathListeners?.();
        }

        createSkateboard() {
            const skateboardPath = `
      M150,0
      C225,0 250,50 250,150
      L250,750
      C250,850 225,900 150,900
      C75,900 50,850 50,750
      L50,150
      C50,50 75,0 150,0
      Z
    `;

            const patternCanvas = document.createElement("canvas");
            patternCanvas.width = 20;
            patternCanvas.height = 20;
            const patternCtx = patternCanvas.getContext("2d");
            patternCtx.fillStyle = "rgba(200, 200, 200, 0.5)";
            patternCtx.fillRect(0, 0, 10, 10);
            patternCtx.fillRect(10, 10, 10, 10);

            const pattern = new fabric.Pattern({
                source: patternCanvas,
                repeat: "repeat",
            });

            const pathObj = new fabric.Path(skateboardPath, {
                fill: pattern,
                stroke: "rgba(0,0,0,0)",
                selectable: false,
                evented: false,
                originX: "center",
                originY: "center",
                objectCaching: false,
            });

            const baseScale =
                0.9 *
                Math.min(
                    this.canvas.width / pathObj.width,
                    this.canvas.height / pathObj.height
                );

            pathObj.set({
                scaleX: baseScale,
                scaleY: baseScale,
                left: this.canvas.width / 2,
                top: this.canvas.height / 2,
            });

            this.clipPath = pathObj;

            // ▓▓▓ Guidelines
            const showGuidelines = $("#toggleGuides").prop("checked");
            this.guidelineObjects = [];

            if (showGuidelines) {
                const guidelineStyles = [
                    { stroke: "#ec008c", dash: [6, 3], offsetX: 0.86, offsetY: 0.99 },
                    { stroke: "#00c853", dash: [], offsetX: 0.89, offsetY: 1 },
                    { stroke: "#29b6f6", dash: [], offsetX: 0.92, offsetY: 1 },
                    { stroke: "#ba68c8", dash: [], offsetX: 0.94, offsetY: 1 },
                    { stroke: "#43a047", dash: [], offsetX: 0.955, offsetY: 1 },
                    { stroke: "#039be5", dash: [], offsetX: 0.975, offsetY: 1 },
                    { stroke: "#ab47bc", dash: [], offsetX: 1.0, offsetY: 1 },
                ];

                guidelineStyles.forEach((style) => {
                    const guide = new fabric.Path(skateboardPath, {
                        fill: "",
                        stroke: style.stroke,
                        strokeWidth: 1,
                        strokeDashArray: style.dash,
                        strokeUniform: true,
                        originX: "center",
                        originY: "center",
                        selectable: false,
                        evented: false,
                        objectCaching: false,
                    });

                    guide.set({
                        scaleX: baseScale * style.offsetX,
                        scaleY: baseScale * style.offsetY,
                        left: this.canvas.width / 2,
                        top: this.canvas.height / 2,
                    });

                    this.guidelineObjects.push(guide);
                });
            }

            // ▓▓▓ Tire Box Images
            const tireImageUrl =
                "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/tire-box.png";
            fabric.Image.fromURL(tireImageUrl, (img) => {
                const boxSize = 50 * baseScale;

                img.set({
                    originX: "center",
                    originY: "center",
                    scaleX: boxSize / img.width,
                    scaleY: boxSize / img.width,
                    selectable: false,
                    evented: false,
                });

                const topBox = fabric.util.object.clone(img);
                topBox.top = this.canvas.height / 2 - 260 * baseScale;
                topBox.left = this.canvas.width / 2;

                const bottomBox = fabric.util.object.clone(img);
                bottomBox.top = this.canvas.height / 2 + 260 * baseScale;
                bottomBox.left = this.canvas.width / 2;

                // ▓▓▓ Add all elements
                this.canvas.add(this.clipPath);
                if (this.uploadedImage) {
                    this.canvas.add(this.uploadedImage);
                }

                this.guidelineObjects.forEach((g) => this.canvas.add(g));
                this.tireBoxes = [topBox, bottomBox];
                this.tireBoxes.forEach((box) => this.canvas.add(box));

                // ▓▓▓ Dimming Overlay (the effect you want)
                if (this.uploadedImage && this.clipPath) {
                    // Remove existing overlay if any
                    if (this.overlayMask) {
                        this.canvas.remove(this.overlayMask);
                        this.overlayMask = null;
                    }

                    const overlay = new fabric.Rect({
                        width: this.canvas.getWidth(),
                        height: this.canvas.getHeight(),
                        left: 0,
                        top: 0,
                        fill: "rgba(255,255,255,0.75)",
                        selectable: false,
                        evented: false,
                    });

                    const hole = new fabric.Path(skateboardPath, {
                        originX: "center",
                        originY: "center",
                        scaleX: baseScale,
                        scaleY: baseScale,
                        left: this.canvas.width / 2,
                        top: this.canvas.height / 2,
                    });
                    hole.absolutePositioned = true;

                    overlay.clipPath = new fabric.Group([hole], {
                        inverted: true,
                        absolutePositioned: true,
                    });

                    this.overlayMask = overlay;
                    this.canvas.add(overlay);
                    overlay.bringToFront();
                }

                // ▓▓▓ Finalize
                [...this.guidelineObjects, ...this.tireBoxes].forEach((el) =>
                    el.bringToFront()
                );
                if (this.overlayMask) this.overlayMask.bringToFront();

                this.resizeImageToFitClipPath();
                this.applyClipPathListeners();
            });
        }

        /**
         * Align a generated contour with the image, leaving a margin if desired,
         * then add both to the canvas.
         */

        alignContourAndImage(contourObj, imageObj) {
            if (!contourObj || !imageObj) return;

            // Reset contour scaling
            contourObj.scale(1).setCoords();

            // Get contour bounding box
            const boundingRect = contourObj.getBoundingRect(true);
            const contourW = boundingRect.width || 1;
            const contourH = boundingRect.height || 1;

            // Scale contour to fit within canvas
            const contourScale = Math.min(
                (this.canvas.width * 0.8) / contourW,
                (this.canvas.height * 0.8) / contourH
            );

            contourObj.scale(contourScale).setCoords();

            // Get new scaled contour dimensions
            const newContourW = contourW * contourScale;
            const newContourH = contourH * contourScale;

            // ✅ Adjust margins dynamically based on aspect ratio
            const imageAspect = imageObj.width / imageObj.height;

            let baseMargins = {
                wide: 0.03, // imageAspect > 2
                tall: 0.06, // imageAspect < 0.5
                standard: 0.08, // 0.5 ≤ imageAspect ≤ 2
            };

            let scaleFactor;
            if (this.contourBorderThickness === 90) {
                scaleFactor = 1; // Small contour
            } else if (this.contourBorderThickness === 130) {
                scaleFactor = 1.5; // Medium contour
            } else if (this.contourBorderThickness === 200) {
                scaleFactor = 2; // Large contour
            } else {
                scaleFactor = 1.2; // Default fallback
            }

            // Apply aspect-ratio-based margin scaling
            if (imageAspect > 2) {
                this.marginPercent = baseMargins.wide * scaleFactor;
            } else if (imageAspect < 0.5) {
                this.marginPercent = baseMargins.tall * scaleFactor;
            } else {
                this.marginPercent = baseMargins.standard * scaleFactor;
            }

            console.log(
                `Margin Factor (Auto): ${this.marginPercent} (Scale Factor: ${scaleFactor})`
            );

            // ✅ Calculate margin
            let margin = newContourW * this.marginPercent;
            margin = Math.max(10, margin); // Ensure minimum margin

            // ✅ Compute target image dimensions inside the contour
            let targetImgW, targetImgH;
            if (imageAspect > newContourW / newContourH) {
                targetImgW = newContourW - margin;
                targetImgH = targetImgW / imageAspect;
            } else {
                targetImgH = newContourH - margin;
                targetImgW = targetImgH * imageAspect;
            }

            // ✅ Scale image to fit within contour
            const scale = Math.min(
                targetImgW / imageObj.width,
                targetImgH / imageObj.height
            );

            imageObj.scale(scale).setCoords();

            // ✅ Properly center both objects
            [contourObj, imageObj].forEach((obj) => {
                obj
                    .set({
                        originX: "center",
                        originY: "center",
                        left: this.canvas.width / 2,
                        top: this.canvas.height / 2,
                    })
                    .setCoords();
            });

            // ✅ Clear and redraw canvas
            this.canvas.clear();
            this.canvas.add(contourObj);
            this.canvas.clipPath = contourObj;
            this.canvas.add(imageObj);
            this.canvas.bringToFront(imageObj);
            this.canvas.renderAll();
            this.applyClipPathListeners();
        }

        applyClipPathListeners() {
            if (!this.canvas.clipPath) return; // ✅ Prevents errors if clipPath is null

            // ✅ Remove previous event bindings to prevent duplicates
            this.canvas.clipPath.off("mouseover mouseout");
            this.canvas.off("mouse:down");

            // ✅ Ensure `.isSelected` property exists
            this.canvas.clipPath.isSelected = false;

            // ✅ Hover effect: Change stroke color on hover
            this.canvas.clipPath.on("mouseover", () => {
                if (!this.canvas.clipPath.isSelected) {
                    this.canvas.clipPath.set("stroke", "#000000");
                    this.canvas.renderAll();
                }
            });

            this.canvas.clipPath.on("mouseout", () => {
                if (!this.canvas.clipPath.isSelected) {
                    this.canvas.clipPath.set("stroke", "darkgrey");
                    this.canvas.renderAll();
                }
            });

            // ✅ Handle click selection behavior
            this.canvas.on("mouse:down", (event) => {
                if (!this.canvas.clipPath) return;

                if (event.target === this.canvas.clipPath) {
                    // ✅ Select clipPath
                    this.canvas.clipPath.set({
                        hasControls: true,
                        hasBorders: true,
                        stroke: "#ec008c",
                    });
                    this.canvas.clipPath.isSelected = true;
                } else {
                    // ✅ Deselect if clicked outside
                    this.canvas.clipPath.set({
                        hasControls: false,
                        hasBorders: false,
                        stroke: "darkgrey",
                    });
                    this.canvas.clipPath.isSelected = false;
                }
                this.canvas.renderAll();
            });
        }

        // -------------------------------------------------------------
        // 7) Resize & Center Logic
        // -------------------------------------------------------------
        resizeImageToFitClipPath() {
            if (!this.uploadedImage || !this.clipPath) return;

            let availableWidth, availableHeight;

            if (this.clipPath instanceof fabric.Circle) {
                availableWidth = this.clipPath.radius * 2 + 10; // Add 10px (5px extra on each side)
                availableHeight = this.clipPath.radius * 2 + 10;
            } else {
                const clipRect = this.clipPath.getBoundingRect(true);
                availableWidth = clipRect.width + 10;
                availableHeight = clipRect.height + 10;
            }

            const scaleX = availableWidth / this.uploadedImage.width;
            const scaleY = availableHeight / this.uploadedImage.height;
            const targetScale = Math.max(scaleX, scaleY);

            this.uploadedImage.scale(targetScale);
            $("#zoomRange").val(this.uploadedImage.scaleX.toFixed(2));
            this.centerObjects();
        }

        centerImage() {
            if (!this.uploadedImage) return;
            this.uploadedImage.set({
                originX: "center",
                originY: "center",
                left: this.canvas.width / 2,
                top: this.canvas.height / 2,
            });
            this.canvas.renderAll();
        }

        centerObjects() {
            [this.uploadedImage, this.clipPath].forEach((obj) => {
                if (obj) {
                    obj.set({
                        originX: "center",
                        originY: "center",
                        left: this.canvas.width / 2,
                        top: this.canvas.height / 2,
                    });
                    obj.setCoords();
                }
            });
            this.canvas.renderAll();
        }

        alignUploadedImage(direction) {
            if (!this.uploadedImage) return;

            const img = this.uploadedImage;
            const canvasW = this.canvas.getWidth();
            const canvasH = this.canvas.getHeight();

            // Use bounding box of clipPath if available
            let bounds = this.clipPath
                ? this.clipPath.getBoundingRect(true)
                : { left: 0, top: 0, width: canvasW, height: canvasH };

            switch (direction) {
                case "left":
                    img.left = bounds.left + img.getScaledWidth() / 2;
                    break;
                case "centerH":
                    img.left = bounds.left + bounds.width / 2;
                    break;
                case "right":
                    img.left = bounds.left + bounds.width - img.getScaledWidth() / 2;
                    break;
                case "top":
                    img.top = bounds.top + img.getScaledHeight() / 2;
                    break;
                case "centerV":
                    img.top = bounds.top + bounds.height / 2;
                    break;
                case "bottom":
                    img.top = bounds.top + bounds.height - img.getScaledHeight() / 2;
                    break;
            }

            img.setCoords();
            this.canvas.renderAll();
        }

        // -------------------------------------------------------------
        // 8) Button Handlers
        // -------------------------------------------------------------
        handleAutoAdjust() {
            if (!this.uploadedImage) return;

            if (this.clipPath) {
                // For other shapes, just re-run the standard resize logic
                this.centerImage();
                this.resizeImageToFitClipPath();
            }
            this.canvas.renderAll();
        }

        async finishEditing() {
            if (!this.uploadedImage || !this.clipPath) {
                this.showError(
                    "Please upload an image and ensure the clipPath exists."
                );
                return;
            }

            const hideList = [];

            // Hide guides and tire boxes for clean version
            if (this.guidelineObjects) {
                this.guidelineObjects.forEach((g) => {
                    hideList.push(g);
                    g.visible = false;
                });
            }

            if (this.tireBoxes) {
                this.tireBoxes.forEach((b) => {
                    hideList.push(b);
                    b.visible = false;
                });
            }

            this.canvas.renderAll();

            try {
                // Get the clean clipped image data URL
                const cleanDataURL = await this.getClippedImageDataURL();

                // Convert data URL to Blob
                const blob = await (await fetch(cleanDataURL)).blob();

                // Create a File object from the Blob
                const file = new File([blob], "custom-skateboard.png", {
                    type: "image/png",
                });

                // Update the state with the edited image
                state.editedImage = file;

                // Update the preview image
                const previewImg = document.getElementById("preview-image");
                isFromFinishEditing = true;
                previewImg.src = cleanDataURL;

                // Show dimensions (similar to file upload)
                const widthInches = (this.uploadedImage.width / 72).toFixed(2);
                const heightInches = (this.uploadedImage.height / 72).toFixed(2);
                document.getElementById("width-inch").textContent = `${8}"`;
                document.getElementById("height-inch").textContent = `${31}"`;

                console.log("Image editing completed and saved to state");
            } catch (err) {
                console.error("Error saving edited image:", err);
                this.showError("Failed to save edited image. Please try again.");
            } finally {
                // Hide the designer tool and show the preview
                $("#designerTool").removeClass("active");
                $("#preview-box").css("display", "block");
                $("#upload-artbox").css("display", "none");

                // Restore guides visibility
                hideList.forEach((obj) => (obj.visible = true));
                this.canvas.renderAll();
            }
        }

        // Helper function to get clipped image data URL
        getClippedImageDataURL() {
            return new Promise((resolve) => {
                const tempCanvas = new fabric.Canvas(null, {
                    width: this.canvas.getWidth(),
                    height: this.canvas.getHeight(),
                    backgroundColor: "transparent",
                });

                const clonePromises = this.canvas
                    .getObjects()
                    .filter((obj) => obj.visible)
                    .map((obj) => {
                        return new Promise((resolve) =>
                            obj.clone((cloned) => {
                                cloned.set({ opacity: 1 });
                                resolve(cloned);
                            })
                        );
                    });

                Promise.all(clonePromises).then((clonedObjects) => {
                    clonedObjects.forEach((clone) => tempCanvas.add(clone));

                    this.clipPath.clone((clonedClip) => {
                        clonedClip.absolutePositioned = true;
                        tempCanvas.clipPath = clonedClip;

                        tempCanvas.renderAll();

                        const fullDataURL = tempCanvas.toDataURL({
                            format: "png",
                            multiplier: 2,
                        });

                        // 👉 Now remove transparent borders from the final PNG
                        cropTransparentImage(fullDataURL).then((croppedDataURL) => {
                            resolve(croppedDataURL);
                        });
                    });
                });
            });
        }

        handleRemoveImage() {
            // ✅ Clear the uploaded image and reset file input
            this.uploadedImage = null;
            this.clipPath = null;
            this.contourObj = null;
            this.currentShape = null;
            this.originalImageFile = null;

            // ✅ Clear the canvas
            this.canvas.clear();
            this.canvas.clipPath = null;

            // ✅ Restore the upload button UI
            $("#image-upload-label").css("display", "flex");
            $("#filename").css("display", "none");

            // ✅ Reset the file input
            $("#ImageUpload").val("");

            // ✅ Disable UI options
            $("#sbFinishEditing").prop("disabled", true);
            $("#autoAdjust").prop("disabled", true);
            $("#remove").prop("disabled", true);
            $("#smallContour").prop("disabled", true);
            $("#mediumContour").prop("disabled", true);
            $("#largeContour").prop("disabled", true);
            $("#canvasMessage").text("");
            $("#canvasMessage").css("display", "none");
        }

        // -------------------------------------------------------------
        // 9) Utility - show messages
        // -------------------------------------------------------------
        showError(message) {
            const msgEl = $("#canvasMessage");
            msgEl.removeClass("warning").addClass("error").text(message).fadeIn();
        }

        showWarning(message) {
            const msgEl = $("#canvasMessage");
            msgEl.removeClass("error").addClass("warning").text(message).fadeIn();
        }
    }

    function cropTransparentImage(dataURL, alphaThreshold = 30, padding = 0) {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = dataURL;

            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = img.width;
                canvas.height = img.height;

                ctx.drawImage(img, 0, 0);

                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const pixels = imageData.data;

                let minX = canvas.width,
                    minY = canvas.height,
                    maxX = 0,
                    maxY = 0;

                for (let y = 0; y < canvas.height; y++) {
                    for (let x = 0; x < canvas.width; x++) {
                        const alpha = pixels[(y * canvas.width + x) * 4 + 3];
                        if (alpha > alphaThreshold) {
                            minX = Math.min(minX, x);
                            minY = Math.min(minY, y);
                            maxX = Math.max(maxX, x);
                            maxY = Math.max(maxY, y);
                        }
                    }
                }

                if (minX > maxX || minY > maxY) {
                    resolve(dataURL); // No visible pixels, return original
                    return;
                }

                // Add padding
                minX = Math.max(0, minX - padding);
                minY = Math.max(0, minY - padding);
                maxX = Math.min(canvas.width, maxX + padding);
                maxY = Math.min(canvas.height, maxY + padding);

                const croppedWidth = maxX - minX;
                const croppedHeight = maxY - minY;

                const croppedCanvas = document.createElement("canvas");
                const croppedCtx = croppedCanvas.getContext("2d");
                croppedCanvas.width = croppedWidth;
                croppedCanvas.height = croppedHeight;

                croppedCtx.drawImage(
                    canvas,
                    minX,
                    minY,
                    croppedWidth,
                    croppedHeight,
                    0,
                    0,
                    croppedWidth,
                    croppedHeight
                );

                resolve(croppedCanvas.toDataURL("image/png"));
            };

            img.onerror = () => {
                console.error("Failed to load image for cropping");
                resolve(dataURL); // Fallback
            };
        });
    }

    // Finally, instantiate the class
    new StickerDesigner();
});
